import { AutoMap } from "@automapper/classes"

export class SamplerAddress {
    @AutoMap()
    Code: string = ''
    @AutoMap()
    DisplayName: string = ''
    @AutoMap()
    Address: string = ''
    @AutoMap()
    SamplerPuid: string = ''
    @AutoMap()
    Latitude: number = -1
    @AutoMap()
    Longitude: number = -1

}